// [   mobile    |    tablet    |    desktop    ]
// [ base |  sm  |  md  |   lg  |   xl  |  xxl  ]
// [0 -> 375 -> 768 -> 1024 -> 1280 -> 1440 -> ∞]

export const breakpoints = {
  xs: 375,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1440,
};
